import { GlobalAction, GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { call, takeLatest } from 'redux-saga/effects';
import { ForkEffect, CallEffect } from '@redux-saga/core/effects'; // NOSONAR
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export const updateAppActionsGenerator = (): (GlobalAction<undefined> | GlobalAction<void>)[] => {
  return [
    new GlobalActions().updateAbgelaufeneVersicherungsbeginn(),
    new GlobalActions().updateBeginnAblaufOfLoadedState(),
    new GlobalActions().checkValidityAktionsNachlassCode(),
  ];
};

export const updateAppSuccessActions = (): Array<string> => [
  GlobalActions.UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN_SUCCESS,
];

export const updateAppFailActions = (): Array<string> => [
  GlobalActions.UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN_FAILED,
];

export function* showErrorPage(): Generator<CallEffect> {
  const globalPut = GlobalPut.getInstance();
  yield call(globalPut.put, new GlobalActions().errorPageRequested());
}

export const updateLoadedStates = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    updateAppActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
    null,
    showErrorPage,
  ),
);

export function* watchUpdateLoadedStates(): Generator<ForkEffect> {
  yield takeLatest(GlobalActions.UPDATE_LOADED_STATES, updateLoadedStates);
}
